import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_639a4e0d";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_639a4e0d" };
/** script content **/
require("./sticky-ele.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex639a4e0d%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fsticky%2Fsticky-ele%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_639a4e0d"],
    ctorType: "component",
    outputPath: "components/index639a4e0d/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
